'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name conversionTracking
    * @description Handles custom tracking events
    **/

    // Needs only be initialized once per page
    var initialize = function () {

        var $forms = $('.umbraco-forms-form form');
        if ($forms.length > 0) {
            setupFormSubmissionTracking($forms);
        }

        var $clickableTargets = $('.clickable');
        if ($clickableTargets.length > 0) {
            setupClickTracking($clickableTargets);
        }

    };

    // Pushes a form event
    // $form and actionName should be provided
    // Can optionally provide trackingValues. If not provided, these values will be determined from hidden fields on the form
    var pushFormEvent = function ($form, actionName, trackingValues) {
        if (!actionName || actionName.length == 0) {
            actionName = 'unknown';
        }

        if (!trackingValues) {
            trackingValues = getTrackingValuesFromForm($form);
        }

        var $popup = $form.closest('[data-popup]');
        var isInPopup = $popup && $popup.length > 0;

        var formTriggeringEvent = !isInPopup ? 'Embedded' : ($popup[0].hasAttribute('data-popup-auto') ? 'Automatic Popup' : 'Click');
        var formDisplayMethod = isInPopup ? 'Popup' : 'Embedded';

        dataLayer.push(
            {
                event: 'GTM Custom Tracking Event',
                pagePath: window.location.pathname,

                formTriggeringEvent: formTriggeringEvent,
                formDisplayMethod: formDisplayMethod,

                trackingCategory: trackingValues.trackingCategory,
                trackingEventAction: actionName,
                trackingFormName: trackingValues.trackingLabel && trackingValues.trackingLabel.length > 0 ? trackingValues.trackingLabel : trackingValues.formName
            }
        );
    }

    var setupClickTracking = function ($targets) {
        $targets.on('click', function () {
            var $this = $(this);

            // get tracking data off of the element being clicked
            var trackingCategory = $this.attr("data-tracking-category");
            var trackingEventAction = $this.attr("data-tracking-action");
            var trackingLabel = $this.attr("data-tracking-label");
            var trackingValue = $this.attr("data-tracking-value");

            // fall back to the default tracking values global to the whole page if the values were not specified on the clickable element
            if (!trackingCategory || trackingCategory.length <= 0) {
                trackingCategory = $('body').attr("data-tracking-page");  //try to get the catagory from the body
            }
            if (!trackingEventAction || trackingEventAction.length <= 0) {
                trackingEventAction = 'click'; //Set the event type to a click
            }

            // fire GTM event
            var trackingParams = {
                event: trackingEventAction,
                pagePath: window.location.pathname,
                trackingCategory: trackingCategory,
                trackingEventAction: trackingEventAction,
                trackingLabel: trackingLabel
            };
            if (trackingValue) {
                $.extend(trackingParams, { trackingValue: trackingValue });
            }

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(trackingParams);
            }
        });
    }

    var setupFormSubmissionTracking = function ($forms) {
        $forms.on('getours-form-submission', function (e) {
            var $form = $(this);
            var trackingValues = getTrackingValuesFromForm($form);
            var isBrochureForm = trackingValues.formName.toLowerCase().indexOf('brochure') > -1;

            if ($form.valid()) {
                if (typeof dataLayer !== 'undefined') {
                    pushFormEvent($form, 'submit', trackingValues);
                }

                if (isBrochureForm) {
                    extendBrochureSignupMailCookie();
                }
            }
        });
    }

    var getTrackingValuesFromForm = function ($form) {
        var $formNameEl = $form.find('[name="FormName"]');
        var $trackingCategoryEl = $form.find('.trackingcategory input');
        var $trackingLabelEl = $form.find('.trackinglabel input');
        var $trackingValueEl = $form.find('.trackingvalue input');

        return {
            trackingCategory: $trackingCategoryEl.length > 0 ? $trackingCategoryEl.val() : '',
            trackingLabel: $trackingLabelEl.length > 0 ? $trackingLabelEl.val() : '',
            trackingValue: $trackingValueEl.length > 0 ? $trackingValueEl.val() : '',
            formName: $formNameEl.val()
        };
    }

    var extendBrochureSignupMailCookie = function () {
        var daysTillExpiration = 365 * 10; // expire in 10 years. (forever!)
        $.cookie('BrochureSignupMail', 'submitted', { domain: 'getours.com', expires: daysTillExpiration, path: '/' });
    }

    // Return an object exposing the public items
    return {
        initialize: initialize,
        pushFormEvent: pushFormEvent
    };

}())